import { useEffect, useState } from 'react';
import { AppId } from 'types/shared/documents/restaurants';
import { db } from 'utils/firebase';

/** The free App Store app (BETA) behind the door, the QR switch and the ticket-mail text. */
export const TICKET_DOOR_APP: AppId = 'ticket_door';

export type TicketDoorAppState = 'loading' | 'active' | 'inactive';

export const hasTicketDoorApp = (apps: unknown) => Array.isArray(apps) && apps.includes(TICKET_DOOR_APP);

/**
 * Whether Ticket-Einlass is activated for exactly this restaurant, live from
 * restaurantData/{id}.apps (the App Store's activation). "loading" until THIS
 * restaurant answered — after a restaurant switch never the previous venue's
 * answer — and "inactive" when it cannot be read. Only "active" shows anything.
 */
export default function useTicketDoorApp(restaurantId: string | null | undefined): TicketDoorAppState {
  const [read, setRead] = useState<{ restaurantId: string; active: boolean } | null>(null);

  useEffect(() => {
    if (!restaurantId) return undefined;
    return db
      .collection('restaurantData')
      .doc(restaurantId)
      .onSnapshot(
        (snapshot) => setRead({ restaurantId, active: hasTicketDoorApp(snapshot.data()?.apps) }),
        () => setRead({ restaurantId, active: false })
      );
  }, [restaurantId]);

  if (!restaurantId || read?.restaurantId !== restaurantId) return 'loading';
  return read.active ? 'active' : 'inactive';
}
